import _ from 'lodash';

export function mergeInvoiceOrderFg(invoiceDetails: any): any[] {
  if(!invoiceDetails) return [];
  if(invoiceDetails.orders.length > 0) {
    const orders = _.map(invoiceDetails.orders, (order: any) => {
      const fg = _.find(_.get(invoiceDetails, 'allFG'),(fg: any) => fg._id == order.fg); 
      return { ...order, fg };
    });
    return orders;
  } else {
    const callOffs = _.map(invoiceDetails.callOffs, (callOffItem: any) => {
      const orderNo = _.last(_.sortBy(_.map(callOffItem.orders, 'order')));
      return { ...callOffItem, orderNo };
    });
    return callOffs;
  }
}